import { getContractList } from 'lib/api/contract';
import { useQuery } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { sort as sortAction } from 'modules/contractSlice';
import { useState } from 'react';
import useQueryDebounce from 'hooks/common/useQueryDebounce';
import useLoginCheck from 'hooks/common/useLoginCheck';

const useContractTable = () => {
  const dispatch = useDispatch();

  const { sort, sortType, search } = useSelector(({ contract }) => contract);
  const debouncedSearch = useQueryDebounce(search);
  const [currentPage, setCurrentPage] = useState(1);

  const { isLoading, error, data, refetch } = useQuery(
    ['contractList', currentPage, sort, sortType, debouncedSearch],
    () =>
      getContractList({
        page: currentPage,
        sort,
        sortType,
        search: debouncedSearch,
      }),
    {
      keepPreviousData: true,
    },
  );
  useLoginCheck(error?.response, refetch);
  const totalPage = Math.ceil(data?.data.list.count / 10);
  const contractList = data?.data.list.rows;

  const onSort = sortType => {
    dispatch(sortAction(sortType));
  };

  return {
    currentPage,
    isLoading,
    error,
    totalPage,
    contractList,
    setCurrentPage,
    onSort,
  };
};

export default useContractTable;
